import axiosInstance from "./axiosInstance";

export const getAllCategories = async () => {
  try {
    const response = await axiosInstance.get("/category", {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch categories");
  }
};

export const getCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`/categoryfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch category");
  }
};

export const createCategory = async (formData) => {
  try {
    const response = await axiosInstance.post("/category", formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create category");
  }
};

export const updateCategory = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/category/${id}`, formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update category");
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`/categorydel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete category");
  }
};